import { render, staticRenderFns } from "./ValidateCertification.vue?vue&type=template&id=4fb2200c&"
import script from "./ValidateCertification.vue?vue&type=script&lang=js&"
export * from "./ValidateCertification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports